import { render, staticRenderFns } from "./AiSidebar.vue?vue&type=template&id=3c2aad58&scoped=true"
import script from "./AiSidebar.vue?vue&type=script&lang=js"
export * from "./AiSidebar.vue?vue&type=script&lang=js"
import style0 from "./AiSidebar.vue?vue&type=style&index=0&id=3c2aad58&prod&lang=scss&scoped=true"
import style1 from "./AiSidebar.vue?vue&type=style&index=1&id=3c2aad58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2aad58",
  null
  
)

export default component.exports